import React from 'react';

import { GridCard } from './grid-card';
import { GridCardHeader } from './grid-card-header';
import { GridCardContent } from './grid-card-content';
import { GridCardProductFooter } from './grid-card-product-footer';
import { GridCardOfferFooter } from './grid-card-offer-footer';

import { BaseProps, Store } from '../../types';

export const ProductGridCard: React.FC<BaseProps> = props => {
  const {
    brand,
    category,
    diffPercentage,
    highlightedName,
    imageSize,
    imageSrc,
    name,
    previousPriceText,
    price,
    properties,
    rank,
    rating,
    reviewCount,
    selectable,
    selected,
    shouldLazyLoadImage,
    store,
    type = 'product',
    link,
    onClick,
    className,
    container,
    background,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
  } = props;

  const cardProps = {
    link,
    className,
    container,
    background,
    selected,
    selectable,
    onClick,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
  };

  const headerProps = {
    brand,
    diffPercentage,
    imageSize,
    imageSrc,
    name,
    selectable,
    selected,
    shouldLazyLoadImage,
  };
  const contentProps = {
    category,
    diffPercentage,
    highlightedName,
    name,
    price,
    properties,
    rank,
    rating,
    reviewCount,
    // Don't show shop logo in content for offers. Only pass currency for offers.
    store:
      type === 'product' ? store : ({ currency: store?.currency } as Store),
  };
  const footerProps = {
    type,
    rank,
    previousPriceText,
    category,
    store,
    link,
    onClick,
  };

  // The card shouldn't be clickable for offers
  const isClickable = type === 'product';

  return (
    <GridCard
      {...cardProps}
      isClickable={isClickable}
      FooterArea={<Footer {...footerProps} />}
      ActionArea={ActionArea}
    >
      <GridCardHeader {...headerProps} />
      <GridCardContent {...contentProps} />
    </GridCard>
  );
};

type FooterProps = Pick<
  BaseProps,
  | 'type'
  | 'rank'
  | 'previousPriceText'
  | 'category'
  | 'store'
  | 'link'
  | 'onClick'
>;

const Footer: React.FC<FooterProps> = props => {
  const {
    type,
    rank,
    previousPriceText,
    category,
    store,
    link,
    onClick,
  } = props;

  const productFooterProps = { rank, previousPriceText, category };
  const offerFooterProps = { store, link, onClick };

  if (type === 'product') {
    return <GridCardProductFooter {...productFooterProps} />;
  }

  if (type === 'offer') {
    return <GridCardOfferFooter {...offerFooterProps} />;
  }

  return null;
};
